var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8168 0.504193C12.4609 0.180408 11.9897 0 11.5 0C11.0103 0 10.5391 0.180408 10.1833 0.504193L0.898918 8.94852C0.614641 9.2074 0.388282 9.51942 0.233712 9.86546C0.0791412 10.2115 -0.000386346 10.5843 1.41115e-06 10.9609V21.235C0.000509521 21.9685 0.303635 22.6718 0.842747 23.1903C1.38186 23.7088 2.11284 24 2.875 24H5.75C6.5125 24 7.24377 23.7085 7.78293 23.1896C8.3221 22.6707 8.625 21.967 8.625 21.2332V16.6218C8.625 16.3772 8.72597 16.1426 8.90569 15.9697C9.08541 15.7967 9.32917 15.6996 9.58333 15.6996H13.4167C13.6708 15.6996 13.9146 15.7967 14.0943 15.9697C14.274 16.1426 14.375 16.3772 14.375 16.6218V21.2332C14.375 21.967 14.6779 22.6707 15.2171 23.1896C15.7562 23.7085 16.4875 24 17.25 24H20.125C20.8875 24 21.6188 23.7085 22.1579 23.1896C22.6971 22.6707 23 21.967 23 21.2332V10.9591C22.9999 10.5826 22.9199 10.2101 22.765 9.86439C22.6101 9.51868 22.3836 9.20703 22.0992 8.94852L12.8168 0.504193Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8809ca49264392c65a0260806106f72d.svg";
export { ForwardRef as ReactComponent };